import { render, staticRenderFns } from "./Collects.vue?vue&type=template&id=c7398fea&scoped=true&"
import script from "./Collects.vue?vue&type=script&lang=js&"
export * from "./Collects.vue?vue&type=script&lang=js&"
import style0 from "./Collects.vue?vue&type=style&index=0&id=c7398fea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7398fea",
  null
  
)

export default component.exports